import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { SubSink } from 'subsink';
import { SwiperOptions } from 'swiper';
import { EventsParams, SwiperComponent } from 'swiper/angular';

import { AdvertisementBanner } from '@app/api/models';
import { environment } from '@environments/environment';

import { AdBannerActions, AdBannerSelectors } from './store/ad-banner.slice';

@Component({
  selector: 'app-ad-banner',
  templateUrl: './ad-banner.component.html',
  styleUrls: ['./ad-banner.component.scss'],
})
export class AdBannerComponent implements OnInit, AfterViewInit {
  @ViewChild('swiperSlideShow', { static: true }) swiper?: SwiperComponent;

  subs = new SubSink();

  readonly imageBaseUrl = `${environment.imageStorageUrl}/`;

  adBanners?: Array<AdvertisementBanner>;

  config: SwiperOptions = {
    loop: true,
    speed: 1500,
    autoplay: { disableOnInteraction: false },
    pagination: { clickable: true, type: 'bullets' },
  };

  constructor(private store: Store, private router: Router) {}

  ngOnInit(): void {
    this.store.dispatch(AdBannerActions.loadAdBanners.trigger());

    this.subs.add(
      this.store.select(AdBannerSelectors.selectAdBanners).subscribe(
        (adBanners) =>
          (this.adBanners = adBanners.map((adBanner) => ({
            ...adBanner,
            imageUrl:
              this.imageBaseUrl + encodeURIComponent(adBanner.imageUrl ?? ''),
          })))
      )
    );
  }

  ngAfterViewInit(): void {
    this.swiper!.swiperRef.autoplay.start();
  }

  navigateToProduct(url?: string) {
    this.router.navigateByUrl('/buying/search/product-details/' + url);
  }

  onSlideChange(params: EventsParams['slideChange']) {
    const [swiper] = params;
    if ((this.adBanners?.length ?? 0) > 0 && swiper.isEnd) {
      setTimeout(() => {
        this.swiper!.swiperRef.slideTo(0);
      }, 2500);
    }
  }
}
